import angular from 'angular';
import ReauthComponent from './reauth.component';
import ReauthService from './reauth.service';

export default angular
  .module('verifyApp.reauth', [])
  .service('Reauth', ReauthService)
  .component('reauth', ReauthComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/auth/reauth/index.js